(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["filter-aside"] && !Shopify.designMode) return;
  try {
    (function () {
    var aside = document.querySelector('[data-filter-aside]');
    if (!aside || aside.dataset.filterAsideInitialized === 'true') return;

    aside.dataset.filterAsideInitialized = 'true';

    var closeTimer = null;
    var previousFocus = null;
    var releaseModalAccessibility = null;

    function openFilters() {
      window.clearTimeout(closeTimer);
      previousFocus = document.activeElement;
      if (releaseModalAccessibility) releaseModalAccessibility();
      aside.classList.remove('is-closing');
      aside.classList.add('is-open');
      aside.setAttribute('aria-hidden', 'false');
      document.body.classList.add('filter-aside-is-open');

      var closeButton = aside.querySelector('[data-filter-close]');
      releaseModalAccessibility = window.themeAccessibility
        ? window.themeAccessibility.activateModal(aside, closeButton)
        : null;
    }

    function closeFilters() {
      if (!aside.classList.contains('is-open')) return;

      if (releaseModalAccessibility) {
        releaseModalAccessibility();
        releaseModalAccessibility = null;
      }

      aside.classList.remove('is-open');
      aside.classList.add('is-closing');
      aside.setAttribute('aria-hidden', 'true');

      closeTimer = window.setTimeout(function () {
        aside.classList.remove('is-closing');
        document.body.classList.remove('filter-aside-is-open');
      }, 260);

      if (previousFocus && typeof previousFocus.focus === 'function') {
        previousFocus.focus();
      }
    }

    document.addEventListener('click', function (event) {
      var openButton = event.target.closest('[data-filter-open]');
      if (openButton) {
        event.preventDefault();
        openFilters();
        return;
      }

      if (event.target.closest('[data-filter-close]')) {
        event.preventDefault();
        closeFilters();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && aside.classList.contains('is-open')) {
        closeFilters();
      }
    });

    document.addEventListener('filter:close', closeFilters);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-mobile-megamenu"] && !Shopify.designMode) return;
  try {
    (function () {
    var headerGroup = document.querySelector('[data-mobile-header-group]');
    if (!headerGroup) return;

    headerGroup.querySelectorAll('.mobile-nav__trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var submenu = trigger.nextElementSibling;
        var open = trigger.getAttribute('aria-expanded') === 'true';

        trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (submenu) {
          submenu.classList.toggle('is-open', !open);
          submenu.setAttribute('aria-hidden', open ? 'true' : 'false');
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-mobile"] && !Shopify.designMode) return;
  try {
    (function () {
    var headerGroup = document.querySelector('[data-mobile-header-group]');
    if (!headerGroup) return;

    var toggle = headerGroup.querySelector('.mobile-menu-toggle');
    var megamenu = headerGroup.querySelector('.mobile-megamenu');
    var openIcon = toggle ? toggle.querySelector('.mobile-menu-toggle__open') : null;
    var closeIcon = toggle ? toggle.querySelector('.mobile-menu-toggle__close') : null;
    var cartButton = headerGroup.querySelector('[data-mobile-cart-open]');
    var mobileSearchInput = headerGroup.querySelector('.mobile-megamenu__inner [data-header-search-input]');
    var mobileSearchForm = headerGroup.querySelector('.mobile-megamenu__inner [data-header-search-form]');
    var mobileCurrencyButtons = headerGroup.querySelectorAll('[data-currency-modal-open]');
    var menuCloseTimer = null;
    var cartCloseTimer = null;
    var currencyCloseTimer = null;
	    var currencyMenuHandoffTimer = null;
	    var returnToMenuAfterCurrency = false;
	    var currencyWasOpen = false;
	    var releaseMenuAccessibility = null;

    function setMenuOpen(open) {
      var wasOpen = headerGroup.classList.contains('is-open');
      var wasOpening = headerGroup.classList.contains('is-opening');
      var wasClosing = headerGroup.classList.contains('is-closing');
      var shouldAnimateClosed = !open && (wasOpen || wasOpening || wasClosing);

      window.clearTimeout(menuCloseTimer);

	      if (open) {
	        if (releaseMenuAccessibility) releaseMenuAccessibility();
	        headerGroup.classList.remove('is-closing');
	        headerGroup.classList.remove('is-open');
	        headerGroup.classList.add('is-opening');

        if (megamenu) {
          megamenu.classList.remove('is-closing');
          megamenu.classList.remove('is-open');
          megamenu.classList.add('is-opening');
          megamenu.setAttribute('aria-hidden', 'false');
        }

        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            if (!headerGroup.classList.contains('is-opening')) return;

            headerGroup.classList.remove('is-opening');
            headerGroup.classList.add('is-open');

	            if (megamenu) {
	              megamenu.classList.remove('is-opening');
	              megamenu.classList.add('is-open');
	            }

	            releaseMenuAccessibility = window.themeAccessibility
	              ? window.themeAccessibility.activateModal(headerGroup, toggle)
	              : null;
	          });
	        });
	      } else {
	        if (releaseMenuAccessibility) {
	          releaseMenuAccessibility();
	          releaseMenuAccessibility = null;
	        }

	        headerGroup.classList.remove('is-opening');
        headerGroup.classList.remove('is-open');
        headerGroup.classList.toggle('is-closing', shouldAnimateClosed);

        if (megamenu) {
          megamenu.classList.remove('is-opening');
          megamenu.classList.remove('is-open');
          megamenu.classList.toggle('is-closing', shouldAnimateClosed);
          megamenu.setAttribute('aria-hidden', 'true');
        }
      }

      if (!open) {
        headerGroup.classList.remove('is-search-open');

        if (mobileSearchInput) {
          mobileSearchInput.value = '';
          mobileSearchInput.dispatchEvent(new Event('input', { bubbles: true }));
          if (document.activeElement === mobileSearchInput) mobileSearchInput.blur();
        }
      }

      if (toggle) {
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.setAttribute('aria-label', open ? toggle.dataset.labelClose : toggle.dataset.labelOpen);
      }

      if (openIcon) openIcon.setAttribute('aria-hidden', open ? 'true' : 'false');
      if (closeIcon) closeIcon.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (open) document.body.style.overflow = 'hidden';

      if (shouldAnimateClosed) {
        menuCloseTimer = window.setTimeout(function () {
          headerGroup.classList.remove('is-closing');
          if (megamenu) megamenu.classList.remove('is-closing');
          document.body.style.overflow = '';
        }, 260);
      } else if (!open) {
        document.body.style.overflow = '';
      }
    }

    function setMobileSearchOpen(open) {
      var wasOpen = headerGroup.classList.contains('is-search-open');
      headerGroup.classList.toggle('is-search-open', open);

      if (open && !wasOpen) {
        document.dispatchEvent(new CustomEvent('header-search:open'));
      }

      if (open && mobileSearchInput) {
        mobileSearchInput.focus({ preventScroll: true });
      }
    }

    function syncMobileCartState() {
      var cartAside = document.querySelector('[data-cart-aside]');
      var isOpen = Boolean(cartAside && (cartAside.classList.contains('is-open') || cartAside.classList.contains('is-opening')));
      var isClosing = Boolean(cartAside && cartAside.classList.contains('is-closing'));
      headerGroup.classList.toggle('is-cart-open', isOpen);
      headerGroup.classList.toggle('is-cart-closing', isClosing);
      if (cartButton && !headerGroup.classList.contains('is-filter-open')) {
        cartButton.setAttribute('aria-label', (isOpen || isClosing) ? 'Close cart' : 'Cart');
      }
    }

    function syncMobileFilterState() {
      var filterAside = document.querySelector('[data-filter-aside]');
      var isOpen = Boolean(filterAside && filterAside.classList.contains('is-open'));
      var isClosing = Boolean(filterAside && filterAside.classList.contains('is-closing'));
      headerGroup.classList.toggle('is-filter-open', isOpen);
      headerGroup.classList.toggle('is-filter-closing', isClosing);
      if (cartButton) {
        cartButton.setAttribute('aria-label', (isOpen || isClosing) ? 'Close filters' : (headerGroup.classList.contains('is-cart-open') || headerGroup.classList.contains('is-cart-closing') ? 'Close cart' : 'Cart'));
      }
    }

    function closeCartAside(cartAside) {
      if (!cartAside || (!cartAside.classList.contains('is-open') && !cartAside.classList.contains('is-opening'))) return;

      window.clearTimeout(cartCloseTimer);
      cartAside.classList.remove('is-opening');
      cartAside.classList.remove('is-open');
      cartAside.classList.add('is-closing');
      cartAside.setAttribute('aria-hidden', 'true');

      cartCloseTimer = window.setTimeout(function () {
        cartAside.classList.remove('is-closing');
        document.body.classList.remove('cart-aside-is-open');
        syncMobileCartState();
      }, 260);

      syncMobileCartState();
    }

    function closeFilterAside(filterAside) {
      if (!filterAside || !filterAside.classList.contains('is-open')) return;

      document.dispatchEvent(new CustomEvent('filter:close'));
    }

    function closeCurrencyPanel() {
      var currencyModal = document.querySelector('[data-currency-modal]');
      if (!currencyModal || (!currencyModal.classList.contains('is-open') && !currencyModal.classList.contains('is-opening'))) return;

      returnToMenuAfterCurrency = false;
      window.clearTimeout(currencyCloseTimer);
      currencyModal.classList.remove('is-opening');
      currencyModal.classList.remove('is-open');
      currencyModal.classList.add('is-closing');
      currencyModal.setAttribute('aria-hidden', 'true');

      currencyCloseTimer = window.setTimeout(function () {
        currencyModal.classList.remove('is-closing');
        document.body.classList.remove('currency-modal-is-open');
      }, 260);
    }

    function toggleCartAside() {
      var cartAside = document.querySelector('[data-cart-aside]');
      var filterAside = document.querySelector('[data-filter-aside]');

      if (filterAside && filterAside.classList.contains('is-open')) {
        closeFilterAside(filterAside);
        return;
      }

      if (cartAside && (cartAside.classList.contains('is-open') || cartAside.classList.contains('is-opening'))) {
        closeCartAside(cartAside);
        return;
      }

      closeCurrencyPanel();

      syncMobileCartState();
      document.dispatchEvent(new CustomEvent('cart:open'));
      setMenuOpen(false);
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        var shouldOpen = !headerGroup.classList.contains('is-open') && !headerGroup.classList.contains('is-opening');
        var cartAside = document.querySelector('[data-cart-aside]');
        var filterAside = document.querySelector('[data-filter-aside]');

        if (shouldOpen && cartAside && (cartAside.classList.contains('is-open') || cartAside.classList.contains('is-opening'))) {
          closeCartAside(cartAside);
        }

        if (shouldOpen && filterAside && filterAside.classList.contains('is-open')) {
          closeFilterAside(filterAside);
        }

        if (shouldOpen) {
          closeCurrencyPanel();
        }

        setMenuOpen(shouldOpen);
      });
    }

    if (cartButton) {
      cartButton.addEventListener('click', toggleCartAside);
    }

    mobileCurrencyButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        returnToMenuAfterCurrency = true;
        window.clearTimeout(currencyMenuHandoffTimer);
        currencyMenuHandoffTimer = window.setTimeout(function () {
          setMenuOpen(false);
        }, 180);
      });
    });

    document.addEventListener('currency-modal:restore-mobile-menu', function () {
      if (!returnToMenuAfterCurrency || !window.matchMedia('(max-width: 749px)').matches) return;
      returnToMenuAfterCurrency = false;
      setMenuOpen(true);
    });

    function syncMobileCurrencyState() {
      var currencyModal = document.querySelector('[data-currency-modal]');
      var isOpen = Boolean(currencyModal && (currencyModal.classList.contains('is-open') || currencyModal.classList.contains('is-opening')));

      if (currencyWasOpen && !isOpen && returnToMenuAfterCurrency && window.matchMedia('(max-width: 749px)').matches) {
        returnToMenuAfterCurrency = false;
        setMenuOpen(true);
      }

      currencyWasOpen = isOpen;
    }

    var currencyModal = document.querySelector('[data-currency-modal]');
    if (currencyModal && window.MutationObserver) {
      currencyWasOpen = currencyModal.classList.contains('is-open');
      new MutationObserver(syncMobileCurrencyState).observe(currencyModal, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    var cartAside = document.querySelector('[data-cart-aside]');
    if (cartAside && window.MutationObserver) {
      new MutationObserver(syncMobileCartState).observe(cartAside, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    var filterAside = document.querySelector('[data-filter-aside]');
    if (filterAside && window.MutationObserver) {
      new MutationObserver(syncMobileFilterState).observe(filterAside, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    syncMobileCartState();
    syncMobileFilterState();

    if (mobileSearchInput) {
      mobileSearchInput.addEventListener('focus', function () {
        setMobileSearchOpen(true);
      });
    }

    if (mobileSearchForm) {
      mobileSearchForm.addEventListener('submit', function () {
        setMobileSearchOpen(true);
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || (!headerGroup.classList.contains('is-open') && !headerGroup.classList.contains('is-opening'))) return;

      if (headerGroup.classList.contains('is-search-open')) {
        setMobileSearchOpen(false);
      } else {
        setMenuOpen(false);
      }
    });

    window.addEventListener('resize', function () {
      if (!window.matchMedia('(max-width: 749px)').matches) {
        setMenuOpen(false);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["image"] && !Shopify.designMode) return;
  try {
    (function () {
    function initializeThemeImages(root) {
      var scope = root || document;

      scope.querySelectorAll('.image:not([data-image-loading-initialized="true"])').forEach(function (image) {
        image.dataset.imageLoadingInitialized = 'true';
        if (image.dataset.forceLoading === 'true') return;

        var img = image.querySelector('img');
        if (!img) {
          image.classList.remove('is-loading');
          image.classList.add('is-error');
          return;
        }

        function markLoaded() {
          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
              image.classList.remove('is-loading');
              image.classList.add('is-loaded');
            });
          });
        }

        function markError() {
          image.classList.remove('is-loading');
          image.classList.add('is-error');
        }

        if (img.complete) {
          if (img.naturalWidth > 0) {
            markLoaded();
          } else {
            markError();
          }
          return;
        }

        img.addEventListener('load', markLoaded, { once: true });
        img.addEventListener('error', markError, { once: true });
      });
    }

    window.initializeThemeImages = initializeThemeImages;
    initializeThemeImages(document);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
	    function closeOtherPickers(activePicker) {
	      document.querySelectorAll('.product-card__size-picker.is-open').forEach(function (picker) {
	        if (picker === activePicker) return;

	        picker.classList.remove('is-open');
	        var trigger = picker.querySelector('[data-product-card-size-trigger]');
	        if (trigger) trigger.setAttribute('aria-expanded', 'false');
	      });
	    }

    function initializeProductCards(root) {
      var scope = root || document;

	      scope.querySelectorAll('.product-card:not([data-product-card-initialized="true"])').forEach(function (card, cardIndex) {
        card.dataset.productCardInitialized = 'true';

        var form = card.querySelector('form');
        var picker = card.querySelector('[data-product-card-size-picker]');
	        var trigger = card.querySelector('[data-product-card-size-trigger]');
	        var select = card.querySelector('[data-product-card-size-select]');
	        var label = card.querySelector('[data-product-card-size-label]');
	        var submit = card.querySelector('[data-product-card-submit]');
	        var menu = card.querySelector('[data-product-card-size-menu]');

	        if (!picker || !trigger || !select || !menu) return;

	        var menuId = (menu.id || 'ProductCardSizeMenu') + '-' + cardIndex + '-' + Math.random().toString(36).slice(2);
	        menu.id = menuId;
	        trigger.setAttribute('aria-controls', menuId);

	        function setPickerOpen(open) {
	          closeOtherPickers(open ? picker : null);
	          picker.classList.toggle('is-open', open);
	          trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
	        }

	        function resetCard() {
	          setPickerOpen(false);
	          select.value = '';
	          if (label) label.textContent = 'Select Size';
	          if (submit) submit.classList.add('is-waiting-for-size');
	          picker.querySelectorAll('[data-product-card-size-option]').forEach(function (option) {
	            option.setAttribute('aria-selected', 'false');
	          });
	        }

	        function selectOption(option) {
	          select.value = option.dataset.value;
	          select.dispatchEvent(new Event('change', { bubbles: true }));
	          if (label) label.textContent = option.dataset.label || option.textContent.trim();
	          if (submit) submit.classList.remove('is-waiting-for-size');

	          picker.querySelectorAll('[data-product-card-size-option]').forEach(function (currentOption) {
	            currentOption.setAttribute('aria-selected', currentOption === option ? 'true' : 'false');
	          });

	          setPickerOpen(false);
	          trigger.focus();
	        }

	        trigger.addEventListener('click', function () {
	          var isOpen = picker.classList.contains('is-open');
	          setPickerOpen(!isOpen);
	          if (isOpen) return;

	          var firstOption = picker.querySelector('[data-product-card-size-option]:not(:disabled)');
	          if (firstOption) firstOption.focus();
	        });

	        picker.querySelectorAll('[data-product-card-size-option]').forEach(function (option, index) {
	          option.addEventListener('click', function () {
	            selectOption(option);
	          });

	          option.addEventListener('keydown', function (event) {
	            var options = Array.prototype.slice.call(picker.querySelectorAll('[data-product-card-size-option]:not(:disabled)'));
	            var currentIndex = options.indexOf(option);
	            var nextIndex = currentIndex;

	            if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % options.length;
	            if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + options.length) % options.length;
	            if (event.key === 'Home') nextIndex = 0;
	            if (event.key === 'End') nextIndex = options.length - 1;

	            if (event.key === 'Enter' || event.key === ' ') {
	              event.preventDefault();
	              selectOption(option);
	              return;
	            }

	            if (event.key === 'Escape') {
	              event.preventDefault();
	              setPickerOpen(false);
	              trigger.focus();
	              return;
	            }

	            if (nextIndex === currentIndex || !options[nextIndex]) return;

	            event.preventDefault();
	            options[nextIndex].focus();
	          });
	        });

	        if (form) {
	          form.addEventListener('submit', function (event) {
	            if (select.value) return;

	            event.preventDefault();
	            setPickerOpen(true);
	            trigger.focus();
	          });
	        }

	        card.addEventListener('pointerleave', function () {
	          if (!card.matches(':focus-within')) resetCard();
	        });

        card.addEventListener('focusout', function () {
          window.setTimeout(function () {
            if (!card.matches(':focus-within') && !card.matches(':hover')) resetCard();
          }, 0);
        });
      });
    }

    window.initializeProductCards = initializeProductCards;
    initializeProductCards(document);

    document.addEventListener('click', function (event) {
      if (event.target.closest('.product-card__size-picker')) return;
      closeOtherPickers();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-aside"] && !Shopify.designMode) return;
  try {
    (function () {
    function initializeHeaderSearch() {
      document.querySelectorAll('[data-header-search-item]').forEach(function (searchItem) {
      if (searchItem.dataset.headerSearchInitialized === 'true') return;

      var input = searchItem.querySelector('[data-header-search-input]');
      var form = searchItem.querySelector('[data-header-search-form]');
      var results = searchItem.querySelector('[data-header-search-results]');
      var productsContainer = searchItem.querySelector('[data-header-search-products]');
      var empty = searchItem.querySelector('[data-header-search-empty]');
      var heading = searchItem.querySelector('[data-header-search-heading]');
	      var viewAll = searchItem.querySelector('[data-header-search-view-all]');
	      var resultsHeader = searchItem.querySelector('[data-header-search-results-header]');
	      var status = searchItem.querySelector('[data-header-search-status]');
	      var searchMenu = searchItem.matches('[data-header-search-menu]') ? searchItem : searchItem.querySelector('[data-header-search-menu]');

	      if (!input || !form || !results || !productsContainer || !empty || !heading || !viewAll || !resultsHeader || !status || !searchMenu) return;

      searchItem.dataset.headerSearchInitialized = 'true';

      var searchUrl = searchMenu.dataset.searchUrl || '/search';
      var requestController = null;
      var debounceTimer = null;
      var activeSearchId = 0;
      var responseCache = {};

    function escapeHtml(value) {
      return String(value || '').replace(/[&<>"']/g, function (character) {
        return {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;'
        }[character];
      });
    }

    function formatPrice(product) {
      return product.price || '';
    }

    function productHandle(product) {
      var url = String(product.url || '');
      var parts = url.split('?')[0].split('/').filter(Boolean);
      return parts[parts.length - 1] || '';
    }

    function isLikelyAddonProduct(product) {
      return productHandle(product).indexOf('addon') !== -1 || String(product.url || '').indexOf('/collections/addons/') !== -1;
    }

    function isLikelyAddonCard(card) {
      if (card.matches('[data-addon-product="true"]')) return true;

      var link = card.querySelector('.product-card__meta-link, .product-card__image-link, a[href*="/products/"]');
      var url = link ? link.getAttribute('href') || '' : '';
      var parts = url.split('?')[0].split('/').filter(Boolean);
      var handle = parts[parts.length - 1] || '';
      var subtitle = card.querySelector('.product-card__subtitle');
      var subtitleText = subtitle ? subtitle.textContent.trim().toLowerCase() : '';

      return handle.indexOf('addon') !== -1 || url.indexOf('/collections/addons/') !== -1 || subtitleText === 'addons';
    }

    function setResultsHeaderVisible(isVisible) {
      resultsHeader.classList.toggle('is-visible', isVisible);
      resultsHeader.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
    }

    function setResultsVisible(isVisible) {
      searchMenu.classList.toggle('is-search-results-active', isVisible);

      if (!isVisible) {
        results.classList.remove('is-ready');
        results.classList.remove('is-visible');
        return;
      }

      results.classList.add('is-visible');
      results.classList.add('is-ready');
    }

    function setLoading(isLoading) {
      productsContainer.classList.toggle('is-loading', isLoading);
    }

	    function clearResults() {
	      productsContainer.innerHTML = '';
	      setLoading(false);
	      empty.hidden = true;
	      status.textContent = '';
	      setResultsVisible(false);
	      setResultsHeaderVisible(false);
	      setViewAll('');
	    }

    function renderLoading(query) {
      heading.textContent = 'Top Results';
      setViewAll(query);
      setResultsHeaderVisible(true);
	      empty.hidden = true;
	      status.textContent = 'Searching for ' + query + '.';
	      productsContainer.innerHTML =
        '<div class="header__search-loading" aria-hidden="true">' +
          '<svg viewBox="0 0 16 16" fill="none">' +
            '<circle cx="8" cy="8" r="6.5" stroke="currentColor" stroke-opacity="0.18" stroke-width="2"/>' +
            '<path d="M14.5 8A6.5 6.5 0 0 0 8 1.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
          '</svg>' +
        '</div>';
      setLoading(true);
      setResultsVisible(true);
    }

    function productHtml(product) {
      var image = product.featured_image || {};
      var imageHtml = image.url
        ? '<span class="product-card__image product-card__image--primary"><img src="' + escapeHtml(image.url) + '" alt="' + escapeHtml(image.alt || product.title) + '" loading="lazy"></span>'
        : '<span class="product-card__image product-card__image--primary"></span>';
      var subtitle = product.vendor || product.type || '';

      return (
        '<article class="product-card" data-header-search-product>' +
          '<div class="product-card__media">' +
            '<a class="product-card__link product-card__image-link" href="' + escapeHtml(product.url) + '">' +
              '<span class="product-card__image-wrap">' + imageHtml + '</span>' +
            '</a>' +
          '</div>' +
          '<a class="product-card__link product-card__meta-link" href="' + escapeHtml(product.url) + '">' +
            '<div class="product-card__meta">' +
              '<div class="product-card__row">' +
                '<h3 class="product-card__title">' + escapeHtml(product.title) + '</h3>' +
                '<span class="product-card__price">' + escapeHtml(formatPrice(product)) + '</span>' +
              '</div>' +
              (subtitle ? '<p class="product-card__subtitle">' + escapeHtml(subtitle) + '</p>' : '') +
            '</div>' +
          '</a>' +
        '</article>'
      );
    }

    function setViewAll(query) {
      var value = query.trim();
      viewAll.href = value ? searchUrl + '?q=' + encodeURIComponent(value) : searchUrl;
    }

    function renderProducts(products, query) {
      var visibleProducts = products.filter(function (product) {
        return !isLikelyAddonProduct(product);
      });
      setLoading(false);
	      productsContainer.innerHTML = visibleProducts.map(productHtml).join('');
	      setResultsVisible(visibleProducts.length > 0);
	      setResultsHeaderVisible(visibleProducts.length > 0);
	      empty.hidden = visibleProducts.length > 0;
	      status.textContent = visibleProducts.length === 1
	        ? '1 result found for ' + query + '.'
	        : visibleProducts.length + ' results found for ' + query + '.';
	      heading.textContent = query.trim() ? 'Top Results' : 'Top Results';
      setViewAll(query);
      initializeRenderedCards();
    }

    function renderProductCards(cards, query) {
      var visibleCards = cards.filter(function (card) {
        return !isLikelyAddonCard(card);
      });

	      setLoading(false);
	      productsContainer.innerHTML = visibleCards.map(function (card) {
	        return card.outerHTML;
	      }).join('');
	      setResultsVisible(visibleCards.length > 0);
	      setResultsHeaderVisible(visibleCards.length > 0);
	      empty.hidden = visibleCards.length > 0;
	      status.textContent = visibleCards.length === 1
	        ? '1 result found for ' + query + '.'
	        : visibleCards.length + ' results found for ' + query + '.';
	      heading.textContent = query.trim() ? 'Top Results' : 'Top Results';
	      setViewAll(query);
	      initializeRenderedCards();
	    }

	    function closeOtherSearchPickers(activePicker) {
	      productsContainer.querySelectorAll('.product-card__size-picker.is-open').forEach(function (picker) {
	        if (picker === activePicker) return;

	        picker.classList.remove('is-open');
	        var trigger = picker.querySelector('[data-product-card-size-trigger]');
	        if (trigger) trigger.setAttribute('aria-expanded', 'false');
	      });
	    }

	    function initializeSearchProductCards() {
	      productsContainer.querySelectorAll('.product-card:not([data-product-card-initialized="true"])').forEach(function (card, cardIndex) {
	        card.dataset.productCardInitialized = 'true';

	        var form = card.querySelector('form');
	        var picker = card.querySelector('[data-product-card-size-picker]');
	        var trigger = card.querySelector('[data-product-card-size-trigger]');
	        var select = card.querySelector('[data-product-card-size-select]');
	        var label = card.querySelector('[data-product-card-size-label]');
	        var submit = card.querySelector('[data-product-card-submit]');
	        var menu = card.querySelector('[data-product-card-size-menu]');

	        if (!picker || !trigger || !select || !menu) return;

	        var menuId = (menu.id || 'ProductCardSizeMenu') + '-search-' + cardIndex + '-' + Math.random().toString(36).slice(2);
	        menu.id = menuId;
	        trigger.setAttribute('aria-controls', menuId);

	        function setPickerOpen(open) {
	          closeOtherSearchPickers(open ? picker : null);
	          picker.classList.toggle('is-open', open);
	          trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
	        }

	        function resetCard() {
	          setPickerOpen(false);
	          select.value = '';
	          if (label) label.textContent = 'Select Size';
	          if (submit) submit.classList.add('is-waiting-for-size');
	          picker.querySelectorAll('[data-product-card-size-option]').forEach(function (option) {
	            option.setAttribute('aria-selected', 'false');
	          });
	        }

	        function selectOption(option) {
	          select.value = option.dataset.value;
	          select.dispatchEvent(new Event('change', { bubbles: true }));
	          if (label) label.textContent = option.dataset.label || option.textContent.trim();
	          if (submit) submit.classList.remove('is-waiting-for-size');

	          picker.querySelectorAll('[data-product-card-size-option]').forEach(function (currentOption) {
	            currentOption.setAttribute('aria-selected', currentOption === option ? 'true' : 'false');
	          });

	          setPickerOpen(false);
	          trigger.focus();
	        }

	        trigger.addEventListener('click', function () {
	          var isOpen = picker.classList.contains('is-open');
	          setPickerOpen(!isOpen);
	          if (isOpen) return;

	          var firstOption = picker.querySelector('[data-product-card-size-option]:not(:disabled)');
	          if (firstOption) firstOption.focus();
	        });

	        picker.querySelectorAll('[data-product-card-size-option]').forEach(function (option) {
	          option.addEventListener('click', function () {
	            selectOption(option);
	          });

	          option.addEventListener('keydown', function (event) {
	            var options = Array.prototype.slice.call(picker.querySelectorAll('[data-product-card-size-option]:not(:disabled)'));
	            var currentIndex = options.indexOf(option);
	            var nextIndex = currentIndex;

	            if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % options.length;
	            if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + options.length) % options.length;
	            if (event.key === 'Home') nextIndex = 0;
	            if (event.key === 'End') nextIndex = options.length - 1;

	            if (event.key === 'Enter' || event.key === ' ') {
	              event.preventDefault();
	              selectOption(option);
	              return;
	            }

	            if (event.key === 'Escape') {
	              event.preventDefault();
	              setPickerOpen(false);
	              trigger.focus();
	              return;
	            }

	            if (nextIndex === currentIndex || !options[nextIndex]) return;

	            event.preventDefault();
	            options[nextIndex].focus();
	          });
	        });

        if (form) {
          form.addEventListener('submit', function (event) {
            if (select.value) return;

	            event.preventDefault();
	            setPickerOpen(true);
	            trigger.focus();
	          });
	        }

	        card.addEventListener('pointerleave', function () {
	          if (!card.matches(':focus-within')) resetCard();
	        });

        card.addEventListener('focusout', function () {
          window.setTimeout(function () {
            if (!card.matches(':focus-within') && !card.matches(':hover')) resetCard();
          }, 0);
        });
      });
    }

    function initializeSearchImages() {
      productsContainer.querySelectorAll('.image:not([data-image-loading-initialized="true"])').forEach(function (image) {
        image.dataset.imageLoadingInitialized = 'true';

        var img = image.querySelector('img');
        if (!img) {
          image.classList.remove('is-loading');
          image.classList.add('is-error');
          return;
        }

        function markLoaded() {
          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
              image.classList.remove('is-loading');
              image.classList.add('is-loaded');
            });
          });
        }

        function markError() {
          image.classList.remove('is-loading');
          image.classList.add('is-error');
        }

        if (img.complete) {
          if (img.naturalWidth > 0) {
            markLoaded();
          } else {
            markError();
          }
          return;
        }

        img.addEventListener('load', markLoaded, { once: true });
        img.addEventListener('error', markError, { once: true });
      });
    }

    function initializeRenderedCards() {
      if (window.initializeProductCards) {
        window.initializeProductCards(productsContainer);
      } else {
        initializeSearchProductCards();
      }

      if (window.initializeThemeImages) {
        window.initializeThemeImages(productsContainer);
      } else {
        initializeSearchImages();
      }
    }

    function productFromSearchResult(searchResult) {
      var link = searchResult.querySelector('.search-result__content a[href*="/products/"], a[href*="/products/"]');
      var image = searchResult.querySelector('.search-result__image img, img');
      var content = searchResult.querySelector('.search-result__content');

      if (!link) return null;

      var title = link.textContent.trim();
      var contentText = content ? content.textContent.replace(link.textContent, '').trim() : '';

      return {
        url: link.getAttribute('href') || '',
        title: title,
        price: contentText,
        vendor: '',
        featured_image: image ? {
          url: image.currentSrc || image.getAttribute('src') || '',
          alt: image.getAttribute('alt') || title
        } : null
      };
    }

    function fallbackSearchProducts(query, searchId) {
      var cacheKey = query.toLowerCase();

      if (responseCache[cacheKey]) {
        renderProductCards(responseCache[cacheKey], query);
        return Promise.resolve();
      }

      return fetch(searchUrl + '?q=' + encodeURIComponent(query) + '&type=product&options[prefix]=last', {
        signal: requestController.signal
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Search fallback failed');
          return response.text();
        })
        .then(function (html) {
          if (searchId !== activeSearchId) return;

          var parsedDocument = new DOMParser().parseFromString(html, 'text/html');
          var productCards = Array.prototype.slice.call(parsedDocument.querySelectorAll('.search-results .product-card'));

          if (productCards.length > 0) {
            responseCache[cacheKey] = productCards;
            renderProductCards(productCards, query);
            return;
          }

          var products = Array.prototype.slice.call(parsedDocument.querySelectorAll('.search-result'))
              .map(productFromSearchResult)
              .filter(Boolean);

          renderProducts(products, query);
        });
    }

    function resetResults() {
      activeSearchId += 1;
      if (requestController) requestController.abort();
      clearResults();
    }

    document.addEventListener('header-search:open', function () {
      input.value = '';
      resetResults();
    });

    function searchProducts(query) {
      var value = query.trim();

      if (value.length < 2) {
        resetResults();
        return;
      }

      if (requestController) requestController.abort();
      requestController = new AbortController();
      activeSearchId += 1;
      renderLoading(value);

      var searchId = activeSearchId;

      fallbackSearchProducts(value, searchId)
        .then(function () {
          if (searchId !== activeSearchId) return;
          setLoading(false);
        })
        .catch(function (error) {
          if (error.name === 'AbortError') return;
          if (searchId !== activeSearchId) return;
          setLoading(false);
          renderProducts([], value);
        });
    }

    input.addEventListener('input', function () {
      window.clearTimeout(debounceTimer);

      if (input.value.trim().length < 2) {
        resetResults();
        return;
      }

      debounceTimer = window.setTimeout(function () {
        searchProducts(input.value);
      }, 300);
    });

    results.addEventListener('click', function (event) {
      var recommendedSearch = event.target.closest('[data-header-recommended-search]');
      if (!recommendedSearch) return;

      event.preventDefault();
      var term = recommendedSearch.dataset.headerRecommendedSearch || '';
      input.value = term;
      input.focus({ preventScroll: true });
      window.clearTimeout(debounceTimer);
      searchProducts(term);
    });

    form.addEventListener('submit', function (event) {
      if (!input.value.trim()) {
        event.preventDefault();
        input.focus();
      }
    });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeHeaderSearch, { once: true });
    } else {
      initializeHeaderSearch();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
